import { API_URL, API_SHOT_URL } from '../config';
import { Url, MongoDocumentId } from '../interfaces/common';
import { Site } from '../interfaces/sites';
import { isSiteProcessed } from '../utils/sites';

export type NextCallback = () => void;
export type SuccessCallback<T> = (data: T) => void;

export const fetchSites = async (
  successCallback: SuccessCallback<Site[]>,
): Promise<void> => {
  const response = await fetch(API_URL);
  const data = await response.json();
  successCallback(data.reverse());
};

export const fetchSite = async (uuid: string): Promise<Site> => {
  const response = await fetch(`${API_URL}/${uuid}`);
  return response.json();
};

export const fetchSiteWithDelay = (
  uuid: string,
  delay: number,
  nextCallback: NextCallback,
  successCallback: SuccessCallback<Site>,
): (() => void) => {
  const timer = setTimeout(async () => {
    const data = await fetchSite(uuid);
    if (isSiteProcessed(data)) {
      return successCallback(data);
    }

    nextCallback();
    return undefined;
  }, delay);

  return () => clearTimeout(timer);
};

export const fetchCurrentUrl = async (
  successCallback: SuccessCallback<Url>,
): Promise<void> => {
  const response = await fetch(API_SHOT_URL);
  const data = await response.text();
  successCallback(data);
};

export const createSite = async ({
  url,
}: Pick<Site, 'url'>): Promise<MongoDocumentId> => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  });

  return response.text();
};
